module.exports = __webpack_public_path__ + "img/pic5.887ed089.jpg";